let gtmInitialized = false;

/**
 * Initialize Google Tag Manager - should only be called after user login
 * @param gtmId - Google Tag Manager ID
 */
export function useGTM(gtmId = '') {
  if (!gtmId || typeof window === 'undefined' || gtmInitialized) {
    return;
  }

  // Create the GTM script
  const script = document.createElement('script');
  script.id = `gtm-script-${gtmId}`;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;

  // Add the script to the document head
  document.head.appendChild(script);

  // Initialize the dataLayer if not already present
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  gtmInitialized = true;
}

/**
 * Initialize GTM after user login - this is the only function that should be called
 * @param gtmId - Google Tag Manager ID (defaults to the app's GTM ID)
 */
export function initializeGTMAfterLogin(gtmId = 'GTM-W657LPVB') {
  // Only initialize GTM for authenticated users
  useGTM(gtmId);
}
